// Imports for external libraries go here.
import { FC, useCallback, useState } from 'react';

// Imports for internal (to the monorepo) libraries go here,
// separated by a blank line from external imports.
// The closer the import is to the file the lower it should be in this list.
import { EditableComponent } from '@adobe/aem-react-editable-components';
import { FormProvider, useForm } from 'react-hook-form';
import { useAuthStore } from '../../store';
import { GlobalStyles, StyledBrgClaimForm } from './BrgClaimForm.styles';
import { BrgClaimFormProps, BrgModelProps, FormData } from './BrgClaimForm.types';
import { BrgForm } from './BrgForm';
import { BrgThankYou } from './BrgThankYou';
import { BrgUnAuth } from './BrgUnAuth';

export const BRGFormConfig = {
  emptyLabel: 'BrgClaimForm',
  isEmpty: () => true,
  resourceType: `${process.env['NEXT_PUBLIC_AEM_SITE']}/components/content/brgclaimform`,
};

export const BrgClaimForm = (props: BrgClaimFormProps) => {
  return (
    <EditableComponent config={BRGFormConfig} {...props}>
      <GlobalStyles />
      <StyledBrgClaimForm data-testid="legal-BrgClaimForm" data-component-name="o-legal-BrgClaimForm">
        <BrgClaimFormComp {...props.model} />
      </StyledBrgClaimForm>
    </EditableComponent>
  );
};

export const BrgClaimFormComp: FC<BrgModelProps> = props => {
  const { isAuthenticated } = useAuthStore();

  if (!isAuthenticated) return <BrgUnAuth {...props} />;
  return <BrgMainComp {...props} />;
};

type ScreenState = 'CLAIM_FORM' | 'THANK_YOU';

export const BrgMainComp: FC<BrgModelProps> = props => {
  const [screen, setScreen] = useState<ScreenState>('CLAIM_FORM');
  const methods = useForm<FormData>();

  const goToThankYou = useCallback(() => setScreen('THANK_YOU'), []);

  return (
    <FormProvider {...methods}>
      {screen === 'CLAIM_FORM' && <BrgForm {...props} goToThankYou={goToThankYou} />}
      {screen === 'THANK_YOU' && <BrgThankYou {...props} />}
    </FormProvider>
  );
};
